export const MONATE = {
  JAN: '01',
  FEB: '02',
  MAR: '03',
  APR: '04',
  MAI: '05',
  JUN: '06',
  JUL: '07',
  AUG: '08',
  SEP: '09',
  OKT: '10',
  NOV: '11',
  DEZ: '12',
} as const;

export type Monate = typeof MONATE;
